import React from "react";
import ReactDOM from "react-dom";
import ViewGrid from "./components/ViewGrid";
import "./index.css";

const viewgrids = document.getElementsByName("viewgrid");

for (let view of viewgrids) {
  const replicaid = view.getAttribute("replicaid");
  const server = view.getAttribute("server");
  const viewname = view.getAttribute("viewname");
  const search = view.getAttribute("search");
  const select = view.getAttribute("select");
  const deletion = view.getAttribute("deletion");
  const expand = view.getAttribute("expand");
  const grouping = view.getAttribute("grouping");
  const id = view.getAttribute("id");

  ReactDOM.render(
    <ViewGrid
      replicaid={replicaid}
      server={server}
      viewname={viewname}
      search={search}
      select={select}
      deletion={deletion}
      expand={expand}
      grouping={grouping}
    />,
    document.getElementById(id)
  );
}
